import { render, staticRenderFns } from "./BaseColorSelector.vue?vue&type=template&id=5243fa06"
import script from "./BaseColorSelector.vue?vue&type=script&lang=js"
export * from "./BaseColorSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports